export default {
  location: 'Location',
  person: 'Person',
  fleet: 'Fleet',
  assets: 'Assets',
  deactivatedPlace: 'This QR Code is linked to a deactivated location.'
}
